import { render, staticRenderFns } from "./LicenciaAlcoholesBitacora.vue?vue&type=template&id=8788c42e&"
import script from "./LicenciaAlcoholesBitacora.vue?vue&type=script&lang=js&"
export * from "./LicenciaAlcoholesBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports